export default {
    review: {
        zhCN: {
            number_order: '序号',
            dealer_num: '经销商网络代码',
            dealer_name: '经销商名称',
            monthly: '月度',
            total_rebate_amount: '返利总金额',
            approver: '审批人',
            approve_time: '审批时间',
            approval_status: '审批状态',
            operation: '操作',
            time_limit: '时间限制',
        },
        enUS: {
            number_order: 'NO.',
            dealer_num: 'Dealer Num',
            dealer_name: 'Dealer Name',
            monthly: 'Monthly',
            total_rebate_amount: 'Total Rebate Amount',
            approver: 'Approver',
            approve_time: 'Approve Time',
            approval_status: 'Approval Status',
            operation: 'Operation',
            time_limit: 'Time Limit',
        },
    },
    salesOrder: {
        zhCN: {
            sales_order: '销售订单',
            dealer_code: '经销商代码',
            dealer_name: '经销商名称',
            order_type: '订单类型',
            vin: 'VIN',
            model: '车型',
            reg_date: '注册日期',
            order_activated_date: '激活日期',
            reg: '注册号',
            reg_type: '注册类型',
            receive_time: '发布时间',
            order_num: '订单号',
            price_term: '价格条款',
            order_date: '下单日期',
            order_status: '订单状态',
            approval_status: '审批状态',
            model_version: '车型/版本',
            series: '车系',
            trim_version: '版本',
            colour: '颜色',
            reg_cancel_date: '注册取消日期',
            channel: '注册方式',
            payment_type: '支付类型',
            coupons_no: '券号',
            credit_company: '信贷公司',
            basic_price: '基础价格（不含税）',
            paint_price: '喷漆费用（不含税）',
            delivery_price: '运费（不含税）',
            total_price: '订单总金额（不含税）',
            mgmfs_invoice: '开票金额',
            currency: '币种',
            rom: '区域经理',
            orderNo: 'Sales Order #',
            sales_order_edit: '注册订单编辑',
            modify_time: '修改时间',
            modify_reason: '修改原因',
            sure_submit: '请确认提交！',
            modifier: '修改人',
            original_mgmfs_invoice: '旧开票金额',
            new_mgmfs_invoice: '新开票金额',
            approval_opinion: '审批意见',
            please_orderNo: '请填写订单号',
            please_vin: '请填写vin码',
            please_modifyOne: '未找到相应订单',
            please_opinion: '拒绝时请输入审批意见',
            approvalRemark: '拒绝原因',
            status: '状态',
            error_msg: '错误信息',
            batch_pass: '批量通过',
            please_batch: '请先勾选批量审核的订单',
            vehicleMaterialCode: '物料号',
            start_registrationDate: '注册开始日期',
            end_registrationDate: '注册结束日期',
            price_term_code: '价格条款',
            template_name: 'Delivery Claim Template.xlsx',
            pickUpListUpload: '自提清单导入',
            inconsistent_basic_price_download: '差异数据下载',
            basic_price_upload: '基准价格导入',
            inconsistent_offline_basic_price: 'Inconsistent Offline Basic Price',
            material_code: '物料号',
            reg_no: '注册号',
            eu_invoice_no: 'Invoice No.',
            eu_invoice_status: 'Invoice Status',
            eu_country_name: 'Country Name',
            eu_country_code: 'Country Code',
            eu_group: 'Group',
            eu_financial_company: 'Financial Company',
            eu_interior_price: 'Interior Price',
            eu_invoice_price: 'Invoice Price',
            eu_unit_price: 'Unit Price(Incl.VAT)',
            eu_cancel_date: 'Cancel Date',
            eu_gate_out_time: 'Gate Out Time',
            eu_transportation_costs: 'Transportation Costs',
            eu_delivery_time: 'Delivery Time',
            eu_related_retail_order: 'Related Retail Order',
            eu_related_wholesales_order: 'Related Wholesales Order',
            eu_fleet_type: 'Fleet Type',
            eu_order_active_date: 'Order Activated Date',
            eu_contract_date: 'Contract Date',
            eu_account_record_type: 'Related Account Record Type',
            eu_incentive_amount: 'Incentive Amount',
            reg_status: 'Reg Status',
            eu_price_term: 'Price Term',
            eu_production_year: 'Production Year',
            eu_sales_type: 'Sales Type',
            eu_pay_bonus: 'Pay Bonus',
            eu_counting_towards_target: 'Counting Towards Target',
            completion_date: 'Completion',
            production_order_no: 'Production Order No.',
            business_customer: '商务客户',
            vehicle_type: '车辆类型',
            company_size: '公司规模',
            financial_support: '财务支持',
            first_registration_date: '首次登记日期',
            eu_customer_type: 'Customer Type',
            eu_sales_dealer: 'Sales Dealer',
            eu_delivery_center: 'Delivery Center',
            roof_price: 'Roof Price',
            seat_price: 'Seat Price',
            exterior_price: 'Exterior Color Pirce',
            fleet_leasing_discount_vat: 'Leasing Discount(%)',
            fleet_leasing_discount: 'Leasing Discount',
            fleet_discount_vat: 'Fleet Discount(%)',
            fleet_discount: 'Fleet Discount',
            eu_contact_person: 'Contact Person',
            eu_dealer_address: 'Dealer Address',
            zip_code: 'Zip Code',
            email: 'Email',
            eu_reg_filling_date: 'Reg Filling Date',
            eu_first_reg_date: 'First Reg Date',
            vehicle_type_history: 'Vehicle Type History',
            original_dealer: 'Original Dealer',
            eu_customer_tier: 'Customer Tier',
            eu_parent_main_dealer: 'Parent Main Dealer',
            eu_parent_main_dealer_code: 'Parent Main Dealer Code',
            eu_parent_main_dealer_name: 'Parent Main Dealer Name',
            eu_dealer_group: 'Dealer Group',
            eu_dealer_region: 'Dealer Region',
            eu_sales_company: 'Sales Company',
        },
        enUS: {
            sales_order: 'Register Sales Order',
            dealer_code: 'Dealer Code',
            dealer_name: 'Dealer Name',
            order_type: 'Order Type',
            vin: 'VIN',
            model: 'Model',
            reg_date: 'Reg Date',
            order_activated_date: 'Order Activated Date',
            reg: 'Reg',
            reg_type: 'Registration Type',
            receive_time: 'Receive Time',
            order_num: 'Order No.',
            price_term: 'Price Term',
            order_date: 'Order Date',
            order_status: 'Order Status',
            approval_status: 'Approval Status',
            model_version: 'Model/Version',
            series: 'Series',
            trim_version: 'Trim Version',
            colour: 'Colour',
            reg_cancel_date: 'Reg Cancel Date',
            channel: 'Channel',
            payment_type: 'Payment Type',
            coupons_no: 'Coupons No.',
            credit_company: 'Credit Company',
            basic_price: 'Basic Price',
            paint_price: 'Paint Price',
            delivery_price: 'Delivery Price',
            total_price: 'Total Price',
            mgmfs_invoice: 'MGMFS Invoice',
            currency: 'Currency',
            rom: 'Rom',
            orderNo: 'Sales Order #',
            sales_order_edit: 'Register Sales Edit',
            modify_time: 'Modify Time',
            modify_reason: 'Modify Reason',
            sure_submit: 'Please confirm the submission!',
            modifier: 'Modifier',
            original_mgmfs_invoice: 'Original MGMFS Invoice',
            new_mgmfs_invoice: 'New MGMFS Invoice',
            approval_opinion: 'Approval Opinion',
            please_orderNo: 'Please input SalesOrder #',
            please_vin: 'Please input vin',
            please_modifyOne: 'No sales orders found',
            please_opinion: 'Please input the approval opinion when refusing',
            approvalRemark: 'Approval Remark',
            status: 'Status',
            error_msg: 'Error Message',
            batch_pass: 'Batch Pass',
            please_batch: 'Please check the order for batch audit first',
            vehicleMaterialCode: 'VMC',
            start_registrationDate: 'Registration start date',
            end_registrationDate: 'Registration end date',
            price_term_code: 'Price Term Code',
            template_name: 'Delivery Claim Template.xlsx',
            pickUpListUpload: 'Delivery Claim Upload',
            inconsistent_basic_price_download: 'Inconsistent Basic Price Download',
            basic_price_upload: 'Basic Price Upload',
            inconsistent_offline_basic_price: 'Inconsistent Offline Basic Price',
            material_code: 'Material Code',
            reg_no: 'Reg No.',
            eu_invoice_no: 'Invoice No.',
            eu_invoice_status: 'Invoice Status',
            eu_country_name: 'Country Name',
            eu_country_code: 'Country Code',
            eu_group: 'Group',
            eu_financial_company: 'Financial Company',
            eu_interior_price: 'Interior Price',
            eu_invoice_price: 'Invoice Price',
            eu_unit_price: 'Unit Price(Incl.VAT)',
            eu_cancel_date: 'Cancel Date',
            eu_gate_out_time: 'Gate Out Time',
            eu_transportation_costs: 'Transportation Costs',
            eu_delivery_time: 'Delivery Time',
            eu_stock_status: 'Stock Status',
            eu_related_retail_order: 'Related Retail Order',
            eu_related_wholesales_order: 'Related Wholesales Order',
            eu_fleet_type: 'Fleet Type',
            eu_order_active_date: 'Order Activated Date',
            eu_contract_date: 'Contract Date',
            eu_account_record_type: 'Related Account Record Type',
            eu_incentive_amount: 'Incentive Amount',
            reg_status: 'Reg Status',
            eu_price_term: 'Price Term',
            eu_production_year: 'Production Year',
            eu_sales_type: 'Sales Type',
            eu_pay_bonus: 'Pay Bonus',
            eu_counting_towards_target: 'Counting Towards Target',
            completion_date: 'Completion',
            production_order_no: 'Production Order No.',
            business_customer: 'Business Customer',
            vehicle_type: 'Vehicle Type',
            company_size: 'Company Size',
            financial_support: 'Financial Support',
            first_registration_date: 'First Registration Date',
            eu_customer_type: 'Customer Type',
            eu_sales_dealer: 'Sales Dealer',
            eu_delivery_center: 'Delivery Center',
            roof_price: 'Roof Price',
            seat_price: 'Seat Price',
            exterior_price: 'Exterior Color Pirce',
            fleet_leasing_discount_vat: 'Leasing Discount(%)',
            fleet_leasing_discount: 'Leasing Discount',
            fleet_discount_vat: 'Fleet Discount(%)',
            fleet_discount: 'Fleet Discount',
            eu_contact_person: 'Contact Person',
            eu_dealer_address: 'Dealer Address',
            zip_code: 'Zip Code',
            email: 'Email',
            eu_reg_filling_date: 'Reg Filling Date',
            eu_first_reg_date: 'First Reg Date',
            vehicle_type_history: 'Vehicle Type History',
            original_dealer: 'Original Dealer',
            eu_customer_tier: 'Customer Tier',
            eu_parent_main_dealer: 'Parent Main Dealer',
            eu_parent_main_dealer_code: 'Parent Main Dealer Code',
            eu_parent_main_dealer_name: 'Parent Main Dealer Name',
            eu_dealer_group: 'Dealer Group',
            eu_dealer_region: 'Dealer Region',
            eu_sales_company: 'Sales Company',
        },
    },
    rrmgmt: {
        zhCN: {
            reg: '注册号',
            reg_date: '注册日期',
            reg_cancel_date: '注册取消日期',
            vin: 'VIN',
            order_type: '订单类型',
            channel: 'Channel',
            price_term: 'Price Term',
            credit_company: '信贷公司',
            payment_type: '付款类型',
            coupon_no: '优惠券',
            quantity: '数量',
            basic_price: '基本价格',
            paint: '油漆',
            delivery: '交付',
            total_price: '总价',
            basic_margin: '基础返利',
            stds_margin: 'Stds Margin',
            vrb: 'Quarterly Bonus',
            cash_olo_finance: 'Cash ILO Finance',
            ev_test_drive: 'Test Drive Support',
            dealer_fleet: 'Dealer Fleet',
            demo: 'Demo',
            courtesy_car: 'Courtesy Car',
            motability: 'Motability',
            affinity: 'Affinity',
            adjustment: 'Adjustment',
            adjustment_import: '导入Adjustment',
            adjustment_reason: 'Adjustment Reason',
            appeal_options: 'Appeal Options',
            total_support: 'Total Support',
            mgmfs_invoice: 'MGMFS Invoice',
            delivery_refund: 'Delivery Refund',
            promotion_total_support: 'Promotion Total Support',
            balance_due_t: '返利金额（不含税）',
            balance_due_z: '返利总金额（不含税）',
            grand_total_t: '返利金额（含税）',
            grand_total_z: '返利总金额（含税）',
            unpaid_vat: '未支付（含税）',
            deduct: '扣除',
            deduct_reason: '扣除原因',
            error_msg: '错误信息',
            other_msg: '申诉回复',
            number_order: '序号',
            rebate_no: '返利编号',
            dealer_code: '经销商代码',
            dealer_name: '经销商名称',
            dealer_group: '经销商组',
            dealer_status: '经销商状态',
            settlement_period: '结算周期',
            advance_payment: '预付金额(不含税)',
            advance_payment_vat: '预付金额(含税)',
            balance_due: '返利总金额(不含税)',
            grand_total: '本次支付 (不含税)',
            grand_total_vat: '本次支付 (含税)',
            difference: '差额 (不含税)',
            pay_status: '支付状态',
            pay_time: '支付时间',
            dealer_feedback_status: '经销商反馈状态',
            dealer_confirm_status: '经销商确认状态',
            appeals: '申诉',
            appeal_deadline: '申诉截止日期',
            is_submitSAP: '是否提交SAP',
            exportSAP: 'SAP导出',
            is_exportSAP: '是否导出SAP',
            confirm_unpaid: '确认且未支付',
            last_approver: '最新审批人',
            last_approve_date: '最新审批时间',
            checker: '确认人',
            confirm_btn: '确认',
            check_time: '确认时间',
            create_time: '创建时间',
            create_date: '创建日期',
            monthly: '月度',
            total_rebate_amount: '返利总金额',
            approver: '审批人',
            approve_time: '审批时间',
            approval_status: '审批状态',
            export_status: '导出状态',
            export_sap_status: '导出SAP状态',
            operation: '操作',
            time_limit: '时间限制',
            submit_sap: '提交 SAP',
            batch_edit_pay_status: '批量编辑付款状态',
            change_pay_status: '更改付款状态',
            quarterly_recalibration: '返利计算',
            appeal_recalibration: '申诉返利计算',
            rebate_calculate: '返利计算',
            please_confirm_that_the_bulk_adjustment_payment_status: '请确认批量调整付款状态：',
            please_confirm_that_the_payment_has_been_completed: '请确认付款已完成',
            click_to_pass: '单击 "通过 "以通过所有选定项目。',
            click_to_approved: '单击 "批准 "以通过所有选定项目。',
            model_version: '型号/版本',
            colour: '颜色',
            color: '颜色',
            order_date: '下单日期',
            summary: '汇总',
            net: '净金额',
            vat: '税额',
            total: '合计',
            sales_target: '销售目标',
            actual_sales: '实际销量',
            achieving_rate: '目标达成率',
            approval_opinion: '审批意见',
            approval_remark: '上级审批备注',
            remark: '备注',
            batch_pass: '批量通过',
            approval_history: '审批历史',
            approval_result: '审批结果',
            invoice_date: ' 发票日期',
            invoice_amount: '发票金额',
            invoice_amount_vat: '发票金额（含税）',
            adjust_sales: '调整',
            fleet: 'Fleet',
            date: '时间',
            month: '月',
            target: '目标',
            // sales: '销售额',
            sales: '销量',
            sales_volume: '销量',
            regs: 'Regs',
            total_target: '总目标',
            total_sales: '总销售额',
            select_quarter: '选择季度',
            appeal_reason: '申诉原因',
            select_quarter_rek: '请勾选需要计算的季度时间段或者KPI 政策',
            select_quarter_down: '*下拉框里的内容是当前开始进行结算的数据',
            select_limit_date:
                '*Only one monthly Rebate Name can be selected for calculation.',
            reasons_for_appeal: '申诉理由',
            d_reasons_for_appeal: '经销商申诉原因',
            rebate_name: '返利名称',
            unconfirm: 'Unconfirm (NET)',
            unpayment: 'Unpayment (NET)',
            unpayment_vat: 'Confirmed Unpaid (Incl.VAT)',
            confirm: 'Confirm (NET)',
            paid: 'Paid (NET)',
            paid_vat: 'Paid (Incl.VAT)',
            sales_are_correct: '确认实际销量',
            target_are_correct: '确认销量目录',
            confirm_tip: '请确认该季度销量是否正确，一旦确认将不再变更销量统计.',
            clear_tip: '请确认所选行的确认状态将被清除。',
            pass_tips: '单击“通过”可通过所有选定项目。',
            payment_per_unit: '单位付款',
            ladder_bonus: 'Ladder Bonus (NET)',
            ladder_fleet: 'Dealer Fleet (NET)',
            average_bonus: 'Average Bonus (NET)',
            confirm_net: 'Confirm (NET)',
            m1_advance_payment: 'M1 Advance Payment (NET)',
            m1_advance_payment_vat: 'M1 Advance Payment (Incl.VAT)',
            m2_advance_payment: 'M2 Advance Payment (NET)',
            m2_advance_payment_vat: 'M2 Advance Payment (Incl.VAT)',
            payment_amount_net: 'Payment Amount (NET)',
            mumber_of_payment: 'Number of Payment',
            target_sales_adj: 'Target/Sales Adj',
            submit_date: 'Submit Date',
            batch_apply_payment: '批量申请支付',
            batch_apply_payment_tip: '请确认提交所选结果！',
            comment: '意见',
            payment_approval: '付款审批',
            region: '地区',
            batch_import_of_adjustments: '调整项批量导入',
            adjustment_item: '调整项',
            please_download_invoice: '发票下载',
            current_total_payment_amount: '当前总付款金额',
            paid_date: '支付日期',
            des_reminders_for_dealer: '已在审核中，审核后才能操作数据',
            des_reminders_for_dealer_no_chance: '申诉次数已用完',
            balance_due_difference: '返利金额差异：',
            computation_reminder: 'Price Term 和 Order Type 必填',
            incl_vat: '含税总计',
            tip_adjustment: '自定义行adjustment列或Adjustment Reason必填',
            achievement_thresholds: '成就阈值',
            total_confirmed: 'Total Confirmed (Incl.VAT)',
            confirm_status: '确认状态',
            confirm_completion: '确认完成',
            appeal_status: '申诉状态',
            appeal_update: 'Appeal Update',
            filter: '过滤',
            clear: '清除',
            confirmed_amount: '确认金额',
            confirmation_date: '确认日期',
            sales_date: '销售日期',
            order_cancel_date: '订单取消日期',
            whole_sale_margin: 'Whole Sale Margin',
            retail_margin: 'Retail Margin',
            bouns: 'Bouns',
            de_for_nonCompliance: 'Deduction for non_compliance',
            dt_code: 'DT',
            dt_codes: 'DT Code',
            eu_rebate_no: '返利编号',
            eu_rebate_name: '返利名称',
            eu_customer_code: '客户代码',
            eu_customer_name: '客户名称',
            eu_customer_status: '客户状态',
            eu_accrual_no: 'Accrual No.',
            eu_advance_payment: '预付金额',
            eu_total_adjustment: '总调整金额',
            eu_advance_payment_net: 'Advance Payment(NET)',
            eu_amount_due_after_advance: 'Amount Due After Advance(NET)',
            eu_total_support_net: 'Total Support(NET)',
            eu_total_support_vat: 'Total Support(Incl.VAT)',
            eu_unpaid: 'Unpaid',
            eu_paid: 'Paid',
            eu_policy_name: 'Policy Portfolio Name',
            eu_material_code: 'Material Code',
            eu_delivery_date: 'Delivery Date',
            eu_wholesales_order_type: 'Wholesales Order Type',
            eu_msrp: 'MSRP',
            eu_msrp_vat: 'MSRP(w/o VAT)',
            eu_msrp_vatr: 'MSRP(Incl. VAT)',
            eu_msrp_net: 'Net MSRP',
            eu_list_price: 'List Price',
            eu_color_price: 'Color Price',
            eu_color_price_vat: 'Color Price(Incl.VAT)',
            eu_exterior_color_price: 'Exterior Color Price',
            eu_kpi_name: 'KPI Policy Name',
            eu_vat_rate: 'VAT Rate',
            eu_last_approver: 'Last Processor',
            eu_latest_time: 'Latest Update Time',
            eu_retail_volume: 'Retail Volume',
            eu_wholesales_volume: 'Wholesales Volume',
            eu_rebate_deduction_no: 'Rebate No/Deduction No',
            eu_rebate_deduction_name: 'Rebate Name/Deduction Name',
            eu_payment_No: 'Payment No',
            eu_remark: '备注',
            eu_remark_return: '审批意见必填！',
            eu_pay_tip:
                'Please confirm that the payment has been completed. The status can not be changed after this operation.',
            eu_business_type: 'Business Type',
            eu_trim: 'Trim',
            eu_rebate_type: 'Rebate Type',
            eu_calculation_time: 'Calculation Time',
            eu_payment_time: 'Payment Time',
            eu_bonus: 'Bonus',
            eu_bonus_vat: 'Bonus(VAT Incl.)',
            eu_wholesales_orders: 'Wholesales Orders',
            eu_retail_orders: 'Retail Orders',
            eu_vehicle_material_code: '物料号',
            eu_order_cancelled_code: '订单取消日期',
            eu_process_status: '进度状态',
            eu_process_date: '进度日期',
            eu_registration_code: 'Registration Code',
            eu_registration_Date: 'Registration Date',
            eu_key: 'Key',
            eu_ttl: 'TTL',
            eu_currency: 'Settlement Currency',
            eu_total_support_id: 'Total Support(Incl.Invoice Discount)',
            eu_invoice_price_vat: 'Invoice Price(Excl.VAT)',
            eu_invoice_discount_vat: 'Invoice Discount(Excl.VAT)',
            eu_tip_adjustment: '自定义行的adjustment列或Adjustment Reason列有值时，另一个必填',
            eu_exterior_code: 'Exterior Code',
            eu_is_export: 'Is Export',
            eu_generate_credit: 'Generate Credit Note',
            eu_settlement_currency: 'Sales Company',
            eu_gate_out_date: 'Gate Out Date',
            after_advance_vat: 'Amount Due after Advance (Incl.VAT)',
            initial_total_vat: 'Initial Total (Incl.VAT)',
            appeals_adjustments_amount_vat: 'Appeals & Adjustments Amount (Incl.VAT)',
            total_unconfirmed_vat: 'Total Unconfirmed (Incl. VAT)',
            eu_marketing_activity: '市场活动',
            eu_marketing_activity_name: '市场活动名称',
            eu_activity_startdate: '活动开始时间',
            eu_activity_enddate: '结束时间',
            order_date_bank: 'Order Date(Bank)',
            inquiry_date_bank: 'Inquiry Date',
            flag_as_a_ticket: 'Flag as a Ticket',
            eu_tip_ticket: 'No data submitted',
            appeal_reason_desc:
                'If you have objections to the entire statement, please enter the reason for your appeal here.',
            billing_group: 'Billing Group',
            adjustment_amount_net: 'Adjustment Amount(NET)',
            confirmation_status: 'Confirmation Status',
            eu_export_sap: 'Export SAP Status',
            eu_tip_other_msg: '单条申诉时Appeal Reply必填',
            eu_tip_apply: '整单申诉时，Appeal Reply必填',
            eu_dealer_region: 'Dealer Region',
            eu_region_manager: 'Region Manager',
            eu_is_primary_account: 'isPrimaryAccount',
            eu_inlog_type: 'Type',
            eu_inlog_amount: 'Amount（Incl.VAT)',
            eu_inlog_invoice: 'Invoice',
            eu_inlog_operator: 'Operator',
            eu_list_price_net: 'List Price(NET)',
            eu_color_price_net: 'Color Price(NET)',
            eu_interior_price_net: 'Interior Price(NET)',
            eu_seat_price_net: 'Seat Price(NET)',
            eu_roof_price_net: 'Roof Price(NET)',
            eu_total_disount: 'Total Discount',
            quote_disount_net: 'Quote Disount(NET)',
            quote_disount_vat: 'Quote Disount(wVAT)',
            declaration_late: 'Declaration Late',
            estimated_delivery_date: 'Estimated Delivery Date',
            delivery_late: 'Delivery Late',
            ventes_en_lot: 'Ventes En Lot',
            palier_de_prime: 'Palier',
            wholesale_invoice_number: 'Wholesale Invoice Number',
            wholesale_invoice_date: 'Wholesale Invoice Date',
            wholesale_invoice_amount: 'Wholesale Invoice Amount',
            eu_approval_remark: '审批备注',
            eu_approval_last_user: 'Final Processor',
            eu_retail_fleet_program: 'Fleet Programm for SalesDealer',
            eu_is_test_drive_reservation: 'Is Test Drive Reservation',
            eu_end_account_record_type: 'End Customer Type',
            eu_fr_demo_date: 'Demo Date',
            eu_interior_color_price: 'Interior Color Price',
            eu_main_account_dealer_code: 'Main Account Dealer Code',
            eu_main_account_dealer_name: 'Main Account Dealer Name',
            eu_single_registration: 'Is Single Day Registration',
            upload_time: '上传时间',
            processor: '处理人',
            eu_commission_blocked: 'Commission Blocked',
            eu_bonus_blocked: 'Bonus Blocked',
            eu_simmix_regMonth: 'Registration Month(simmix)',
            eu_confirm_amount_vat: 'Confirmed Amount (Incl. VAT)',
            eu_unconfirm_amount_vat: 'Unconfirmed Amount (Incl. VAT)',
            eu_update_time: 'Update Time',
            eu_unpaid_amount: 'Unpaid Amount',
            eu_fr_b2b_code: 'B2B Code',
        },
        enUS: {
            date: 'Date',
            reg: 'Reg',
            reg_date: 'Reg Date',
            reg_cancel_date: 'Reg Cancel Date',
            vin: 'VIN',
            order_type: 'Order Type',
            channel: 'Channel',
            price_term: 'Price Term',
            credit_company: 'Credit Company',
            payment_type: 'Payment Type',
            coupon_no: 'Coupon No',
            quantity: 'Quantity',
            basic_price: 'Basic Price',
            paint: 'Paint',
            delivery: 'Delivery',
            total_price: 'Total Price',
            basic_margin: 'Basic Margin',
            stds_margin: 'Stds Margin',
            vrb: 'Quarterly Bonus',
            cash_olo_finance: 'Cash ILO Finance',
            ev_test_drive: 'Test Drive Support',
            dealer_fleet: 'Dealer Fleet',
            demo: 'Demo',
            courtesy_car: 'Courtesy Car',
            motability: 'Motability',
            affinity: 'Affinity',
            adjustment: 'Adjustment',
            adjustment_import: 'Adjustment Import',
            adjustment_reason: 'Adjustment Reason',
            appeal_options: 'Appeal Options',
            total_support: 'Total Support',
            mgmfs_invoice: 'MGMFS Invoice',
            balance_due_t: 'Balance Due',
            delivery_refund: 'Delivery Refund',
            promotion_total_support: 'Promotion Total Support',
            balance_due_z: 'Total Amount(NET)',
            grand_total_t: 'Grand Total',
            grand_total_z: 'Total Amount(Incl.VAT)',
            unpaid_vat: 'Unpaid(Incl.VAT)',
            deduct: 'Deduct',
            deduct_reason: 'Deduct Reason',
            error_msg: 'Error Message',
            other_msg: 'Appeal Reply',
            number_order: 'NO.',
            rebate_no: 'Rebate Reference',
            dealer_code: 'Dealer Code',
            dealer_name: 'Dealer Name',
            dealer_group: 'Dealer Group',
            dealer_status: 'Dealer Status',
            settlement_period: 'Settlement Period',
            advance_payment: 'Advance Payment (NET)',
            advance_payment_vat: 'Advance Payment (Incl.VAT)',
            balance_due: 'Balance Due (NET)',
            grand_total: 'Grand Total (NET)',
            grand_total_vat: 'Grand Total (Incl.VAT)',
            difference: 'Difference (NET)',
            pay_status: 'Pay Status',
            pay_time: 'QTLY PMT',
            dealer_feedback_status: 'Dealer Feedback Status',
            dealer_confirm_status: 'Dealer Confirm Status',
            appeals: 'Appeals',
            appeal_deadline: 'Appeal Deadline',
            is_submitSAP: 'Is SubmitSAP',
            exportSAP: 'SAP Export',
            is_exportSAP: 'Is ExportSAP',
            confirm_unpaid: 'Confirm&Unpaid',
            last_approver: 'Last Approver',
            last_approve_date: 'Last Approve Date',
            checker: 'Checker',
            confirm_btn: 'Confirm',
            check_time: 'Check Time',
            create_time: 'Create Time',
            create_date: 'CreatedDate',
            monthly: 'Monthly',
            total_rebate_amount: 'Total Rebate Amount',
            approver: 'Approver',
            approve_time: 'Approvel Time',
            approval_status: 'Approval Status',
            export_status: 'Export Status',
            export_sap_status: 'Export Sap Status',
            operation: 'Operation',
            time_limit: 'Time Limit',
            submit_sap: 'Submit SAP',
            batch_edit_pay_status: 'Batch Edit Pay Status',
            change_pay_status: 'Change Pay Status',
            quarterly_recalibration: 'Calculation',
            appeal_recalibration: 'Appeal Calculation',
            rebate_calculate: 'Rebate Calculation',
            please_confirm_that_the_bulk_adjustment_payment_status:
                'Please confirm that the bulk adjustment payment status：',
            please_confirm_that_the_payment_has_been_completed:
                'Please confirm that the payment has been completed',
            click_to_pass: 'Click ‘Pass’ to pass all of selected items.',
            click_to_approved: 'Click ‘Approved’ to pass all of selected items.',
            model_version: 'Model / Version',
            colour: 'Colour',
            color: 'Color',
            order_date: 'Order Date',
            summary: 'Summary',
            net: 'NET',
            vat: 'VAT',
            total: 'TOTAL',
            sales_target: 'Sales Target',
            actual_sales: 'Actual Sales',
            achieving_rate: 'Achieving Rate',
            approval_opinion: 'Approval opinion',
            approval_remark: 'Remarks for superior approval',
            remark: 'Remark:',
            batch_pass: 'Batch Pass',
            approval_history: 'Approval History',
            approval_result: 'Approval Result',
            invoice_date: ' Invoice Date',
            invoice_amount: 'Invoice Amount',
            invoice_amount_vat: 'Invoice Amount(Incl.VAT)',
            adjust_sales: 'Adjust Sales',
            fleet: 'Fleet',
            month: 'Month',
            target: 'Target',
            sales: 'Sales',
            sales_volume: 'Sales Volume',
            regs: 'Regs',
            total_target: 'Total Target',
            total_sales: 'Total sales',
            select_quarter: 'Select Quarter',
            appeal_reason: 'Appeal Reason',
            select_quarter_rek:
                'Please select the periods or KPI policy that you want to calculate.',
            select_quarter_down:
                '*The items in the drop-down box are the data for the currently starting billing process',
            select_limit_date:
                '*Only one monthly Rebate Name can be selected for calculation.',
            reasons_for_appeal: 'Reasons For Appeal',
            d_reasons_for_appeal: 'Reason For Dealer Appeal',
            rebate_name: 'Rebate Name',
            unconfirm: 'Unconfirm (NET)',
            unpayment: 'Unpayment (NET)',
            unpayment_vat: 'Confirmed Unpaid (Incl.VAT)',
            confirm: 'Confirm (NET)',
            paid: 'Paid (NET)',
            paid_vat: 'Paid (Incl.VAT)',
            sales_are_correct: 'Sales Are Correct',
            target_are_correct: 'Target Are Correct',
            confirm_tip:
                'Please confirm the sales order quantity in this quarter. After confirmed, the sales data (target and sales) cannot be change.',
            clear_tip:
                'Please confirm that the confirmation status of the selected row will be cleared.',
            pass_tips: 'Click "Pass" to pass all of selected items.',
            payment_per_unit: 'Payment Per Unit',
            ladder_bonus: 'Ladder Bonus (NET)',
            ladder_fleet: 'Dealer Fleet (NET)',
            average_bonus: 'Average Bonus (NET)',
            confirm_net: 'Confirm (NET)',
            m1_advance_payment: 'M1 Advance Payment (NET)',
            m1_advance_payment_vat: 'M1 Advance Payment (Incl.VAT)',
            m2_advance_payment: 'M2 Advance Payment (NET)',
            m2_advance_payment_vat: 'M2 Advance Payment (Incl.VAT)',
            payment_amount_net: 'Payment Amount (NET)',
            mumber_of_payment: 'Number of Payment',
            target_sales_adj: 'Target/Sales Adj',
            submit_date: 'Submit Date',
            batch_apply_payment: 'Batch Apply Payment',
            batch_apply_payment_tip: 'Please confirm the submission of the selected results!',
            comment: 'Comment',
            payment_approval: 'Payment Approval',
            region: 'Region',
            batch_import_of_adjustments: 'Batch Import Of Adjustments',
            adjustment_item: 'Adjustment Item',
            please_download_invoice: 'Invoice Download',
            current_total_payment_amount: 'Current Total Payment Amount',
            paid_date: 'Paid Date',
            des_reminders_for_dealer: 'In processing, unable to submit',
            des_reminders_for_dealer_no_chance: 'There is no chance to appeal',
            balance_due_difference: 'new balance due - old balance due:',
            computation_reminder: 'Price Term and Order Type is required',
            incl_vat: 'Payment Amount(Incl.VAT)',
            tip_adjustment: 'Custom row adjustment column or Adjustment Reason required',
            achievement_thresholds: 'Achievement Thresholds',
            total_confirmed: 'Total Confirmed (Incl.VAT)',
            confirm_status: 'Confirm Status',
            confirm_completion: 'Confirm Completion',
            appeal_status: 'Appeal Status',
            appeal_update: 'Appeal Update',
            filter: 'filter',
            clear: 'clear',
            confirmed_amount: 'Confirmed Amount(Incl.VAT)',
            confirmation_date: 'Confirmation Date',
            sales_date: 'Sales Date',
            order_cancel_date: 'Order Cancel Date',
            whole_sale_margin: 'Whole Sale Margin',
            retail_margin: 'Retail Margin',
            bouns: 'Bouns',
            de_for_nonCompliance: 'Deduction for non_compliance',
            dt_code: 'DT',
            dt_codes: 'DT Code',
            eu_rebate_no: 'Rebate No.',
            eu_rebate_name: 'Rebate Name',
            eu_customer_code: 'Customer Code',
            eu_customer_name: 'Customer Name',
            eu_customer_status: 'Customer Status',
            eu_accrual_no: 'Accrual No.',
            eu_advance_payment: 'Advance Payment',
            eu_total_adjustment: 'Total Adjustment',
            eu_advance_payment_net: 'Advance Payment(NET)',
            eu_amount_due_after_advance: 'Amount Due After Advance(NET)',
            eu_total_support_net: 'Total Support(NET)',
            eu_total_support_vat: 'Total Support(Incl.VAT)',
            eu_unpaid: 'Unpaid',
            eu_paid: 'Paid',
            eu_policy_name: 'Policy Portfolio Name',
            eu_material_code: 'Material Code',
            eu_delivery_date: 'Delivery Date',
            eu_wholesales_order_type: 'Wholesales Order Type',
            eu_msrp: 'MSRP',
            eu_msrp_vat: 'MSRP(w/o VAT)',
            eu_msrp_vatr: 'MSRP(Incl.VAT)',
            eu_msrp_net: 'Net MSRP',
            eu_list_price: 'List Price',
            eu_color_price: 'Color Price',
            eu_color_price_vat: 'Color Price(Incl.VAT)',
            eu_exterior_color_price: 'Exterior Color Price',
            eu_kpi_name: 'KPI Policy Name',
            eu_vat_rate: 'VAT rate',
            eu_last_approver: 'Last Processor',
            eu_latest_time: 'Latest Update Time',
            eu_retail_volume: 'Retail Volume',
            eu_wholesales_volume: 'Wholesales Volume',
            eu_rebate_deduction_no: 'Rebate No/Deduction No',
            eu_rebate_deduction_name: 'Rebate Name/Deduction Name',
            eu_payment_No: 'Payment No',
            eu_remark: 'Remark',
            eu_remark_return: 'Approval Opinion is required！',
            eu_pay_tip:
                'Please confirm that the payment has been completed. The status can not be changed after this operation.',
            eu_business_type: 'Business Type',
            eu_trim: 'Trim',
            eu_rebate_type: 'Rebate Type',
            eu_calculation_time: 'Calculation Time',
            eu_payment_time: 'Payment Time',
            eu_bonus: 'Bonus',
            eu_bonus_vat: 'Bonus(VAT Incl.)',
            eu_wholesales_orders: 'Wholesales Orders',
            eu_retail_orders: 'Retail Orders',
            eu_vehicle_material_code: 'Vehicle Material Code',
            eu_order_cancelled_code: 'Order Cancelled Date',
            eu_process_status: 'Process Status',
            eu_process_date: 'Process Time',
            eu_registration_code: 'Registration Code',
            eu_registration_Date: 'Registration Date',
            eu_key: 'Key',
            eu_ttl: 'TTL',
            eu_currency: 'Settlement Currency',
            eu_total_support_id: 'Total Support(Incl.Invoice Discount)',
            eu_invoice_price_vat: 'Invoice Price(Excl.VAT)',
            eu_invoice_discount_vat: 'Invoice Discount(Excl.VAT)',
            eu_tip_adjustment:
                'When the adjustment column or adjustment reason column of a custom row has a value, the other one is required',
            eu_exterior_code: 'Exterior Code',
            eu_is_export: 'Is Export',
            eu_generate_credit: 'Generate Credit Note',
            eu_settlement_currency: 'Sales Company',
            eu_gate_out_date: 'Gate Out Date',
            after_advance_vat: 'Amount Due after Advance (Incl.VAT)',
            initial_total_vat: 'Initial Total (Incl.VAT)',
            appeals_adjustments_amount_vat: 'Appeals & Adjustments Amount (Incl.VAT)',
            total_unconfirmed_vat: 'Total Unconfirmed (Incl. VAT)',
            eu_marketing_activity: 'Marketing Activity',
            eu_marketing_activity_name: 'Marketing Activity Name',
            eu_activity_startdate: 'Activity Start Date',
            eu_activity_enddate: 'End Date',
            order_date_bank: 'Order Date(Bank)',
            inquiry_date_bank: 'Inquiry Date',
            flag_as_a_ticket: 'Flag as a Ticket',
            eu_tip_ticket: 'No data submitted',
            appeal_reason_desc:
                'If you have objections to the entire statement, please enter the reason for your appeal here.',
            billing_group: 'Billing Group',
            adjustment_amount_net: 'Adjustment Amount(NET)',
            confirmation_status: 'Confirmation Status',
            eu_export_sap: 'Export SAP Status',
            eu_tip_other_msg: 'When submitting a single appeal, the "Appeal Reply" is required.',
            eu_tip_apply: 'When submitting a full appeal, the "Appeal Reply" is required.',
            eu_dealer_region: 'Dealer Region',
            eu_region_manager: 'Region Manager',
            eu_is_primary_account: 'isPrimaryAccount',
            eu_inlog_type: 'Type',
            eu_inlog_amount: 'Amount（Incl.VAT)',
            eu_inlog_invoice: 'Invoice',
            eu_inlog_operator: 'Operator',
            eu_list_price_net: 'List Price(NET)',
            eu_color_price_net: 'Color Price(NET)',
            eu_interior_price_net: 'Interior Price(NET)',
            eu_seat_price_net: 'Seat Price(NET)',
            eu_roof_price_net: 'Roof Price(NET)',
            eu_total_disount: 'Total Discount',
            quote_disount_net: 'Quote Disount(NET)',
            quote_disount_vat: 'Quote Disount(wVAT)',
            declaration_late: 'Declaration Late',
            estimated_delivery_date: 'Estimated Delivery Date',
            delivery_late: 'Delivery Late',
            ventes_en_lot: 'Ventes En Lot',
            palier_de_prime: 'Palier',
            wholesale_invoice_number: 'Wholesale Invoice Number',
            wholesale_invoice_date: 'Wholesale Invoice Date',
            wholesale_invoice_amount: 'Wholesale Invoice Amount',
            eu_approval_remark: 'Approval Remark',
            eu_approval_last_user: 'Final Processor',
            eu_retail_fleet_program: 'Fleet Programm for SalesDealer',
            eu_is_test_drive_reservation: 'Is Test Drive Reservation',
            eu_end_account_record_type: 'End Customer Type',
            eu_fr_demo_date: 'Demo Date',
            eu_interior_color_price: 'Interior Color Price',
            eu_main_account_dealer_code: 'Main Account Dealer Code',
            eu_main_account_dealer_name: 'Main Account Dealer Name',
            eu_single_registration: 'Is Single Day Registration',
            upload_time: 'Upload Time',
            processor: 'Processor',
            eu_commission_blocked: 'Commission Blocked',
            eu_bonus_blocked: 'Bonus Blocked',
            eu_simmix_regMonth: 'Registration Month(simmix)',
            eu_confirm_amount_vat: 'Confirmed Amount (Incl. VAT)',
            eu_unconfirm_amount_vat: 'Unconfirmed Amount (Incl. VAT)',
            eu_update_time: 'Update Time',
            eu_unpaid_amount: 'Unpaid Amount',
            eu_fr_b2b_code: 'B2B Code',
        },
    },
    rrapproval: {
        zhCN: {
            number_order: '序号',
            rebate_no: '返利编号',
            dealer_code: '经销商代码',
            dealer_name: '经销商名称',
            dealer_status: '经销商状态',
            settlement_period: '结算周期',
            advance_payment: '预付金额(不含税)',
            balance_due: '返利总金额(不含税)',
            grand_total: '本次支付 (不含税)',
            pay_status: '支付状态',
            dealer_feedback_status: '经销商反馈状态',
            is_submitSAP: '是否提交SAP',
            last_approver: '最新审批人',
            last_approve_date: '最新审批时间',
            checker: '确认人',
            check_time: '确认时间',
            create_time: '创建时间',
            monthly: '月度',
            total_rebate_amount: '返利总金额',
            approver: '审批人',
            approve_time: '审批时间',
            approval_status: '审批状态',
            operation: '操作',
            time_limit: '时间限制',
            batch_pass: '批量通过',
            start_createtime: '创建开始时间',
            end_createtime: '创建结束时间',
            approved_time: '审核时间',
        },
        enUS: {
            number_order: 'NO.',
            rebate_no: 'Rebate Reference',
            dealer_code: 'Dealer Code',
            dealer_name: 'Dealer Name',
            dealer_status: 'Dealer Status',
            settlement_period: 'Settlement Period',
            advance_payment: 'Advance Payment (NET)',
            balance_due: 'Balance Due (NET)',
            grand_total: 'Grand Total (NET)',
            pay_status: 'Pay Status',
            dealer_feedback_status: 'Dealer Feedback Status',
            is_submitSAP: 'Is SubmitSAP',
            last_approver: 'Last Approver',
            last_approve_date: 'Last Approve Date',
            checker: 'Checker',
            check_time: 'Check Time',
            create_time: 'Create Time',
            monthly: 'Monthly',
            total_rebate_amount: 'Total Rebate Amount',
            approver: 'Approver',
            approve_time: 'Approve Time',
            approval_status: 'Approval Status',
            operation: 'Operation',
            time_limit: 'Time Limit',
            batch_pass: 'Batch Pass',
            start_createtime: 'CreateTime Start Date',
            end_createtime: 'CreateTime End Date',
            approved_time: 'Approved Time',
        },
    },
    creditNote: {
        zhCN: {
            document_no: 'Document No.',
            external_document_no: 'External Document No.',
            sell_customer_no: 'Sell-to Customer No.',
            bill_customer_no: 'Bill-to Customer No.',
            bank_no: 'Bank No.',
            posting_description: 'Posting Description',
            header_text: 'Header Text',
            footer_text: 'Footer Text',
            original_document_no: 'Original Document No.',
            periodical_settlement: 'Periodical Settlement',
            posting_date: 'Posting Date',
            document_date: 'Document Date',
            vat_date: 'VAT Date',
            due_date: 'Due Date',
            currency_code: 'Currency Code',
            currency_factor: 'Currency Factor',
            vat_currency_factor: 'VAT Currency Factor',
            currency_factor_tax: 'Currency Factor(Tax Return)',
            type: 'Type',
            line_description: 'Line Description',
            quantity: 'Quantity',
            unit_of_measure_code: 'Unit of Measure Code',
            unit_price_fcy: 'Unit Price (FCY)',
            gen_prod_posting_group: 'Gen. Prod. Posting Group',
            vat_prod_posting_group: 'VAT Prod. Posting Group',
            global_diml_code: 'Global Diml code',
            ending_date: 'Ending Date',
        },
        enUS: {
            document_no: 'Document No.',
            external_document_no: 'External Document No.',
            sell_customer_no: 'Sell-to Customer No.',
            bill_customer_no: 'Bill-to Customer No.',
            bank_no: 'Bank No.',
            posting_description: 'Posting Description',
            header_text: 'Header Text',
            footer_text: 'Footer Text',
            original_document_no: 'Original Document No.',
            periodical_settlement: 'Periodical Settlement',
            posting_date: 'Posting Date',
            document_date: 'Document Date',
            vat_date: 'VAT Date',
            due_date: 'Due Date',
            currency_code: 'Currency Code',
            currency_factor: 'Currency Factor',
            vat_currency_factor: 'VAT Currency Factor',
            currency_factor_tax: 'Currency Factor(Tax Return)',
            type: 'Type',
            line_description: 'Line Description',
            quantity: 'Quantity',
            unit_of_measure_code: 'Unit of Measure Code',
            unit_price_fcy: 'Unit Price (FCY)',
            gen_prod_posting_group: 'Gen. Prod. Posting Group',
            vat_prod_posting_group: 'VAT Prod. Posting Group',
            global_diml_code: 'Global Diml code',
            ending_date: 'Ending Date',
        },
    },
    financialReconciliation: {
        zhCN: {
            generate_text: '确定生成对账单',
            financial_company: '金融公司',
            rebate_type: '返利类型',
            reconciliation_status: '对账状态',
            reconciliation_file: '对账文件',
            financial_total_amount: '金融公司上传总金额',
            MGBP_total_amount: '返利计算金额',
            amount_variance: '差异金额',
            vin: 'VIN',
            customer_code: 'Customer Code',
            dealer_code: 'Dealer Code',
            customer_name: 'Customer Name',
            material_code: 'Material Code',
            model: 'Model',
            trim_version: 'Trim Version',
            color: 'Color',
            inquiry_date: 'Inquiry Date',
            financial_support: 'Financial Support',
            list_price: 'List Price',
            msrp: 'MSRP',
            exterior_color_pirce: 'Exterior Color Pirce',
            discount: 'Discount',
            fb_amount: 'Amount by Financial Company',
            variance: 'Variance',
        },
        enUS: {
            generate_text: 'Generate the statement of account',
            financial_company: 'Financial Company',
            rebate_type: 'Rebate Type',
            reconciliation_status: 'Reconciliation Status',
            reconciliation_file: 'Reconciliation File',
            financial_total_amount: 'Financial Company Total Amount',
            MGBP_total_amount: 'MGBP Total Amount',
            amount_variance: 'Amount Of Variance',
            vin: 'VIN',
            customer_code: 'Customer Code',
            dealer_code: 'Dealer Code',
            customer_name: 'Customer Name',
            material_code: 'Material Code',
            model: 'Model',
            trim_version: 'Trim Version',
            color: 'Color',
            inquiry_date: 'Inquiry Date',
            financial_support: 'Financial Support',
            list_price: 'List Price',
            msrp: 'MSRP',
            exterior_color_pirce: 'Exterior Color Pirce',
            discount: 'Discount',
            fb_amount: 'Amount by Financial Company',
            variance: 'Variance',
        },
    },
    campaignCenter: {
        zhCN: {
            contract_date: '合同日期',
            sales_order: '销售订单',
            vin: 'VIN',
            materialCode: 'Material Code',
            dealer_name_code: 'Dealer Name/Customer Code',
            registration_date: 'Registration Date',
            dealer_code: 'Dealer Code',
            customer_name: 'Customer Name',
            dealer_name: 'Dealer Name',
            customer_code: 'Customer Code',
            campaign_description: 'Campaign Description',
            amount: 'Amount',
            credit_note_date: 'Credit Note Date',
            payment_date: 'Payment Date',
            reason: 'Reason',
            model_description: 'Model Description',
        },
        enUS: {
            contract_date: 'Contract Date',
            sales_order: 'Sales Order',
            vin: 'VIN',
            materialCode: 'Material Code',
            dealer_name_code: 'Dealer Name/Cutomer Code',
            registration_date: 'Registration Date',
            dealer_code: 'Dealer Code',
            customer_name: 'Customer Name',
            dealer_name: 'Dealer Name',
            customer_code: 'Customer Code',
            campaign_description: 'Campaign Description',
            amount: 'Amount',
            credit_note_date: 'Credit Note Date',
            payment_date: 'Payment Date',
            reason: 'Reason',
            model_description: 'Model Description',
        },
    },
    dealerRrInquiry: {
        zhCN: {
            serial_number: '序号',
            eu_rebate_name: '返利名称',
            eu_customer_code: '客户代码',
            eu_customer_name: '客户名称',
            eu_customer_status: '客户状态',
            settlement_period: '结算周期',
            approval_status: '审批状态',
            pay_status: '支付状态',
            confirmation_status: 'Confirmation Status',
            eu_advance_payment: '预付金额',
            eu_total_support_net: 'Total Support(NET)',
            eu_total_support_vat: 'Total Support(Incl.VAT)',
            eu_currency: 'Settlement Currency',
            eu_unpaid_de: 'Unpaid',
            eu_unpaid: 'Unpaid',
            eu_paid: 'Paid',
            appeal_update: 'Appeal Update',
            eu_policy_name: 'Policy Portfolio Name',
            create_time: '创建时间',
            operation: '操作',
            confirm_btn: '确认',
            detail: '详情',
            date: 'Date',
            more: '更多',
            eu_kpi_name: 'KPI Policy Name',
            target: '目标',
            reg: '注册号',
            summary: '汇总',
            net: '净金额',
            vat: '税额',
            total: '合计',
            total_support: 'Total Support',
            vin: 'VIN',
            dealer_feedback_status: '经销商反馈状态',
            confirmation_date: '确认日期',
            appeal_reason: '申诉原因',
            other_msg: '申诉回复',
            eu_material_code: 'Material Code',
            model_version: '型号/版本',
            color: '颜色',
            reg_date: '注册日期',
            eu_reg_filling_date: 'Reg Filling Date',
            quote_disount_net: 'Quote Disount(NET)',
            quote_disount_vat: 'Quote Disount(wVAT)',
            declaration_late: 'Declaration Late',
            estimated_delivery_date: 'Estimated Delivery Date',
            delivery_late: 'Delivery Late',
            eu_order_active_date: 'Order Activated Date',
            eu_first_reg_date: 'First Reg Date',
            reg_cancel_date: '注册取消日期',
            order_type: '订单类型',
            eu_price_term: 'Price Term',
            vehicle_type_history: 'Vehicle Type History',
            business_customer: '商务客户',
            company_size: '公司规模',
            ventes_en_lot: 'Ventes En Lot',
            eu_business_type: 'Business Type',
            eu_fleet_type: 'Fleet Type',
            invoice_date: ' 发票日期',
            eu_gate_out_date: 'Gate Out Date',
            eu_delivery_date: 'Delivery Date',
            order_date: '下单日期',
            contract_date: '合同日期',
            inquiry_date_bank: 'Inquiry Date',
            order_date_bank: 'Order Date(Bank)',
            eu_wholesales_order_type: 'Wholesales Order Type',
            wholesale_invoice_number: 'Wholesale Invoice Number',
            wholesale_invoice_date: 'Wholesale Invoice Date',
            wholesale_invoice_amount: 'Wholesale Invoice Amount',
            quantity: '数量',
            eu_msrp: 'MSRP',
            eu_list_price: 'List Price',
            eu_color_price: 'Color Price',
            eu_interior_price: 'Interior Price',
            eu_currency_de: '币种',
            adjustment_de: 'Adjustment',
            adjustment_reason_de: 'Adjustment Reason',
            eu_total_support_net_de: 'Total Support(NET)',
            eu_total_support_vat_de: 'Total Support(Incl.VAT)',
            eu_vat_rate: 'VAT Rate',
            financial_support: 'Financial Support',
            appealed_history: '申诉历史',
            appeal_files: '附件',
            export: '导出',
            cancel: '取消',
            appeal_reason_desc:
                'If you have objections to the entire statement, please enter the reason for your appeal here.',
            file_name: '文件名称',
            operater: '操作者',
            upload_time: '更新时间',
            version_no: '版本号',
            username: '用户名',
            help: 'Help',
            eu_dealer_appeal: 'Appeal',
            eu_dealer_confirm: 'Confirm',
            eu_dealer_invoice_pdf: 'Invoice PDF',
            eu_dealer_generate_pdf: 'Generate PDF',
            eu_dealer_invoice: 'Invoice',
            // TODO
            channel: 'Channel',
            price_term: 'Price Term',
            credit_company: '信贷公司',
            payment_type: '付款类型',
            coupon_no: '优惠券',
            basic_price: '基本价格',
            paint: '油漆',
            delivery: '交付',
            total_price: '总价',
            basic_margin: '基础返利',
            stds_margin: 'Stds Margin',
            vrb: 'Quarterly Bonus',
            cash_olo_finance: 'Cash ILO Finance',
            ev_test_drive: 'Test Drive Support',
            dealer_fleet: 'Dealer Fleet',
            demo: 'Demo',
            courtesy_car: 'Courtesy Car',
            motability: 'Motability',
            affinity: 'Affinity',
            adjustment: 'Adjustment',
            adjustment_import: '导入Adjustment',
            adjustment_reason: 'Adjustment Reason',
            appeal_options: 'Appeal Options',
            mgmfs_invoice: 'MGMFS Invoice',
            delivery_refund: 'Delivery Refund',
            promotion_total_support: 'Promotion Total Support',
            balance_due_t: '返利金额（不含税）',
            balance_due_z: '返利总金额（不含税）',
            grand_total_t: '返利金额（含税）',
            grand_total_z: '返利总金额（含税）',
            unpaid_vat: '未支付（含税）',
            deduct: '扣除',
            deduct_reason: '扣除原因',
            error_msg: '错误信息',
            number_order: '序号',
            rebate_no: '返利编号',
            dealer_code: '经销商代码',
            dealer_name: '经销商名称',
            dealer_group: '经销商组',
            dealer_status: '经销商状态',
            advance_payment: '预付金额(不含税)',
            advance_payment_vat: '预付金额(含税)',
            balance_due: '返利总金额(不含税)',
            grand_total: '本次支付 (不含税)',
            grand_total_vat: '本次支付 (含税)',
            difference: '差额 (不含税)',
            pay_time: '支付时间',
            dealer_confirm_status: '经销商确认状态',
            appeals: '申诉',
            appeal_deadline: '申诉截止日期',
            is_submitSAP: '是否提交SAP',
            exportSAP: 'SAP导出',
            is_exportSAP: '是否导出SAP',
            confirm_unpaid: '确认且未支付',
            last_approver: '最新审批人',
            last_approve_date: '最新审批时间',
            checker: '确认人',
            check_time: '确认时间',
            monthly: '月度',
            total_rebate_amount: '返利总金额',
            approver: '审批人',
            approve_time: '审批时间',
            export_status: '导出状态',
            export_sap_status: '导出SAP状态',
            time_limit: '时间限制',
            submit_sap: '提交 SAP',
            batch_edit_pay_status: '批量编辑付款状态',
            change_pay_status: '更改付款状态',
            quarterly_recalibration: '返利计算',
            appeal_recalibration: '申诉返利计算',
            rebate_calculate: '返利计算',
            please_confirm_that_the_bulk_adjustment_payment_status: '请确认批量调整付款状态：',
            please_confirm_that_the_payment_has_been_completed: '请确认付款已完成',
            click_to_pass: '单击 "通过 "以通过所有选定项目。',
            click_to_approved: '单击 "批准 "以通过所有选定项目。',
            colour: '颜色',
            sales_target: '销售目标',
            actual_sales: '实际销量',
            achieving_rate: '目标达成率',
            approval_opinion: '审批意见',
            approval_remark: '上级审批备注',
            remark: '备注',
            batch_pass: '批量通过',
            approval_history: '审批历史',
            approval_result: '审批结果',
            invoice_amount: '发票金额',
            invoice_amount_vat: '发票金额（含税）',
            adjust_sales: '调整',
            fleet: 'Fleet',
            month: '月',
            // sales: '销售额',
            sales: '销量',
            sales_volume: '销量',
            regs: 'Regs',
            total_target: '总目标',
            total_sales: '总销售额',
            select_quarter: '选择季度',
            select_quarter_rek: '请勾选需要计算的季度时间段或者KPI 政策',
            select_quarter_down: '*下拉框里的内容是当前开始进行结算的数据',
            reasons_for_appeal: '申诉理由',
            d_reasons_for_appeal: '经销商申诉原因',
            rebate_name: '返利名称',
            unconfirm: 'Unconfirm (NET)',
            unpayment: 'Unpayment (NET)',
            unpayment_vat: 'Confirmed Unpaid (Incl.VAT)',
            confirm: 'Confirm (NET)',
            paid: 'Paid (NET)',
            paid_vat: 'Paid (Incl.VAT)',
            sales_are_correct: '确认实际销量',
            target_are_correct: '确认销量目录',
            confirm_tip: '请确认该季度销量是否正确，一旦确认将不再变更销量统计.',
            clear_tip: '请确认所选行的确认状态将被清除。',
            pass_tips: '单击“通过”可通过所有选定项目。',
            payment_per_unit: '单位付款',
            ladder_bonus: 'Ladder Bonus (NET)',
            ladder_fleet: 'Dealer Fleet (NET)',
            average_bonus: 'Average Bonus (NET)',
            confirm_net: 'Confirm (NET)',
            m1_advance_payment: 'M1 Advance Payment (NET)',
            m1_advance_payment_vat: 'M1 Advance Payment (Incl.VAT)',
            m2_advance_payment: 'M2 Advance Payment (NET)',
            m2_advance_payment_vat: 'M2 Advance Payment (Incl.VAT)',
            payment_amount_net: 'Payment Amount (NET)',
            mumber_of_payment: 'Number of Payment',
            target_sales_adj: 'Target/Sales Adj',
            submit_date: 'Submit Date',
            batch_apply_payment: '批量申请支付',
            batch_apply_payment_tip: '请确认提交所选结果！',
            comment: '意见',
            payment_approval: '付款审批',
            region: '地区',
            batch_import_of_adjustments: '调整项批量导入',
            adjustment_item: '调整项',
            please_download_invoice: '发票下载',
            current_total_payment_amount: '当前总付款金额',
            paid_date: '支付日期',
            des_reminders_for_dealer: '已在审核中，审核后才能操作数据',
            des_reminders_for_dealer_no_chance: '申诉次数已用完',
            balance_due_difference: '返利金额差异：',
            computation_reminder: 'Price Term 和 Order Type 必填',
            incl_vat: '含税总计',
            tip_adjustment: '自定义行adjustment列或Adjustment Reason必填',
            achievement_thresholds: '成就阈值',
            total_confirmed: 'Total Confirmed (Incl.VAT)',
            confirm_status: '确认状态',
            confirm_completion: '确认完成',
            appeal_status: '申诉状态',
            filter: '过滤',
            clear: '清除',
            confirmed_amount: '确认金额',
            sales_date: '销售日期',
            order_cancel_date: '订单取消日期',
            whole_sale_margin: 'Whole Sale Margin',
            retail_margin: 'Retail Margin',
            bouns: 'Bouns',
            de_for_nonCompliance: 'Deduction for non_compliance',
            dt_code: 'DT',
            dt_codes: 'DT Code',
            eu_rebate_no: '返利编号',
            eu_accrual_no: 'Accrual No.',
            eu_total_adjustment: '总调整金额',
            eu_msrp_vat: 'MSRP(w/o VAT)',
            eu_msrp_vatr: 'MSRP(Incl. VAT)',
            eu_msrp_net: 'Net MSRP',
            eu_color_price_vat: 'Color Price(Incl.VAT)',
            eu_exterior_color_price: 'Exterior Color Price',
            eu_last_approver: 'Last Processor',
            eu_latest_time: 'Latest Update Time',
            eu_retail_volume: 'Retail Volume',
            eu_wholesales_volume: 'Wholesales Volume',
            eu_rebate_deduction_no: 'Rebate No/Deduction No',
            eu_rebate_deduction_name: 'Rebate Name/Deduction Name',
            eu_remark: '备注',
            eu_remark_return: '审批意见必填！',
            eu_pay_tip:
                'Please confirm that the payment has been completed. The status can not be changed after this operation.',
            eu_trim: 'Trim',
            eu_rebate_type: 'Rebate Type',
            eu_calculation_time: 'Calculation Time',
            eu_payment_time: 'Payment Time',
            eu_bonus: 'Bonus',
            eu_bonus_vat: 'Bonus(VAT Incl.)',
            eu_wholesales_orders: 'Wholesales Orders',
            eu_retail_orders: 'Retail Orders',
            eu_vehicle_material_code: '物料号',
            eu_order_cancelled_code: '订单取消日期',
            eu_process_status: '进度状态',
            eu_process_date: '进度日期',
            eu_registration_code: 'Registration Code',
            eu_registration_Date: 'Registration Date',
            eu_key: 'Key',
            eu_ttl: 'TTL',
            eu_total_support_id: 'Total Support(Incl.Invoice Discount)',
            eu_invoice_price_vat: 'Invoice Price(Excl.VAT)',
            eu_invoice_discount_vat: 'Invoice Discount(Excl.VAT)',
            eu_tip_adjustment: '自定义行的adjustment列或Adjustment Reason列有值时，另一个必填',
            eu_exterior_code: 'Exterior Code',
            eu_is_export: 'Is Export',
            eu_generate_credit: 'Generate Credit Note',
            eu_settlement_currency: 'Sales Company',
            after_advance_vat: 'Amount Due after Advance (Incl.VAT)',
            initial_total_vat: 'Initial Total (Incl.VAT)',
            appeals_adjustments_amount_vat: 'Appeals & Adjustments Amount (Incl.VAT)',
            total_unconfirmed_vat: 'Total Unconfirmed (Incl. VAT)',
            eu_marketing_activity: '市场活动',
            eu_marketing_activity_name: '市场活动名称',
            eu_activity_startdate: '活动开始时间',
            eu_activity_enddate: '结束时间',
            flag_as_a_ticket: 'Flag as a Ticket',
            eu_tip_ticket: 'No data submitted',
            billing_group: 'Billing Group',
            adjustment_amount_net: 'Adjustment Amount(NET)',
            eu_export_sap: 'Export SAP Status',
            eu_tip_other_msg: '单条申诉时Appeal Reply必填',
            eu_tip_apply: '整单申诉时，Appeal Reply必填',
            eu_dealer_region: 'Dealer Region',
            eu_inlog_type: 'Type',
            eu_inlog_amount: 'Amount（Incl.VAT)',
            eu_inlog_invoice: 'Invoice',
            eu_inlog_operator: 'Operator',
            eu_list_price_net: 'List Price(NET)',
            eu_color_price_net: 'Color Price(NET)',
            eu_interior_price_net: 'Interior Price(NET)',
            eu_seat_price_net: 'Seat Price(NET)',
            eu_roof_price_net: 'Roof Price(NET)',
            eu_invoice_status: 'Invoice Status',
            eu_amount_due_after_advance: '扣除预付款后的应付金额(净值)',
            eu_confirm_amount_vat: '已确认金额(含税)',
            eu_unconfirm_amount_vat: '未确认金额(含税)',
        },
        enUS: {
            serial_number: 'No.',
            eu_rebate_name: 'Rebate Name',
            eu_customer_code: 'Customer Code',
            eu_customer_name: 'Customer Name',
            eu_customer_status: 'Customer Status',
            settlement_period: 'Settlement Period',
            approval_status: 'Approval Status',
            pay_status: 'Pay Status',
            confirmation_status: 'Confirmation Status',
            eu_advance_payment: 'Advance Payment',
            eu_total_support_net: 'Total Support(NET)',
            eu_total_support_vat: 'Total Support(Incl.VAT)',
            eu_currency: 'Settlement Currency',
            eu_unpaid_de: 'Unpaid',
            eu_unpaid: 'Unpaid',
            eu_paid: 'Paid',
            appeal_update: 'Appeal Update',
            eu_policy_name: 'Policy Portfolio Name',
            create_time: 'Create Time',
            operation: 'Operation',
            confirm_btn: 'Confirm',
            detail: 'Detail',
            date: 'Date',
            more: 'More',
            eu_kpi_name: 'KPI Policy Name',
            target: 'Target',
            reg: 'Reg',
            summary: 'Summary',
            net: 'NET',
            vat: 'VAT',
            total: 'TOTAL',
            total_support: 'Total Support',
            vin: 'VIN',
            dealer_feedback_status: 'Dealer Feedback Status',
            confirmation_date: 'Confirmation Date',
            appeal_reason: 'Appeal Reason',
            other_msg: 'Appeal Reply',
            eu_material_code: 'Material Code',
            model_version: 'Model / Version',
            color: 'Color',
            reg_date: 'Reg Date',
            eu_reg_filling_date: 'Reg Filling Date',
            quote_disount_net: 'Quote Disount(NET)',
            quote_disount_vat: 'Quote Disount(wVAT)',
            declaration_late: 'Declaration Late',
            estimated_delivery_date: 'Estimated Delivery Date',
            delivery_late: 'Delivery Late',
            eu_order_active_date: 'Order Activated Date',
            eu_first_reg_date: 'First Reg Date',
            reg_cancel_date: 'Reg Cancel Date',
            order_type: 'Order Type',
            eu_price_term: 'Price Term',
            vehicle_type_history: 'Vehicle Type History',
            business_customer: 'Business Customer',
            company_size: 'Company Size',
            ventes_en_lot: 'Ventes En Lot',
            eu_business_type: 'Business Type',
            eu_fleet_type: 'Fleet Type',
            invoice_date: ' Invoice Date',
            eu_gate_out_date: 'Gate Out Date',
            eu_delivery_date: 'Delivery Date',
            order_date: 'Order Date',
            contract_date: 'Contract Date',
            inquiry_date_bank: 'Inquiry Date',
            order_date_bank: 'Order Date(Bank)',
            eu_wholesales_order_type: 'Wholesales Order Type',
            wholesale_invoice_number: 'Wholesale Invoice Number',
            wholesale_invoice_date: 'Wholesale Invoice Date',
            wholesale_invoice_amount: 'Wholesale Invoice Amount',
            quantity: 'Quantity',
            eu_msrp: 'MSRP',
            eu_list_price: 'List Price',
            eu_color_price: 'Color Price',
            eu_interior_price: 'Interior Price',
            eu_currency_de: 'Currency',
            adjustment_de: 'Adjustment',
            adjustment_reason_de: 'Adjustment Reason',
            eu_total_support_net_de: 'Total Support(NET)',
            eu_total_support_vat_de: 'Total Support(Incl.VAT)',
            eu_vat_rate: 'VAT rate',
            financial_support: 'Financial Support',
            appealed_history: 'Appealed History',
            appeal_files: 'Attachments',
            export: 'Export',
            cancel: 'Cancel',
            appeal_reason_desc:
                'If you have objections to the entire statement, please enter the reason for your appeal here.',
            file_name: 'File Name',
            operater: 'Operater',
            upload_time: 'Upload Time',
            version_no: 'Version No.',
            username: 'Username',
            help: 'Help',
            eu_dealer_appeal: 'Appeal',
            eu_dealer_confirm: 'Confirm',
            eu_dealer_generate_pdf: 'Generate PDF',
            eu_dealer_invoice_pdf: 'Invoice PDF',
            eu_dealer_invoice: 'Invoice',
            // TODO
            channel: 'Channel',
            price_term: 'Price Term',
            credit_company: 'Credit Company',
            payment_type: 'Payment Type',
            coupon_no: 'Coupon No',
            basic_price: 'Basic Price',
            paint: 'Paint',
            delivery: 'Delivery',
            total_price: 'Total Price',
            basic_margin: 'Basic Margin',
            stds_margin: 'Stds Margin',
            vrb: 'Quarterly Bonus',
            cash_olo_finance: 'Cash ILO Finance',
            ev_test_drive: 'Test Drive Support',
            dealer_fleet: 'Dealer Fleet',
            demo: 'Demo',
            courtesy_car: 'Courtesy Car',
            motability: 'Motability',
            affinity: 'Affinity',
            adjustment: 'Adjustment',
            adjustment_import: 'Adjustment Import',
            adjustment_reason: 'Adjustment Reason',
            appeal_options: 'Appeal Options',
            mgmfs_invoice: 'MGMFS Invoice',
            balance_due_t: 'Balance Due',
            delivery_refund: 'Delivery Refund',
            promotion_total_support: 'Promotion Total Support',
            balance_due_z: 'Total Amount(NET)',
            grand_total_t: 'Grand Total',
            grand_total_z: 'Total Amount(Incl.VAT)',
            deduct: 'Deduct',
            deduct_reason: 'Deduct Reason',
            error_msg: 'Error Message',
            number_order: 'NO.',
            rebate_no: 'Rebate Reference',
            dealer_code: 'Dealer Code',
            dealer_name: 'Dealer Name',
            dealer_group: 'Dealer Group',
            dealer_status: 'Dealer Status',
            advance_payment: 'Advance Payment (NET)',
            advance_payment_vat: 'Advance Payment (Incl.VAT)',
            balance_due: 'Balance Due (NET)',
            grand_total: 'Grand Total (NET)',
            grand_total_vat: 'Grand Total (Incl.VAT)',
            difference: 'Difference (NET)',
            pay_time: 'QTLY PMT',
            dealer_confirm_status: 'Dealer Confirm Status',
            appeals: 'Appeals',
            appeal_deadline: 'Appeal Deadline',
            is_submitSAP: 'Is SubmitSAP',
            exportSAP: 'SAP Export',
            is_exportSAP: 'Is ExportSAP',
            confirm_unpaid: 'Confirm&Unpaid',
            last_approver: 'Last Approver',
            last_approve_date: 'Last Approve Date',
            checker: 'Checker',
            check_time: 'Check Time',
            monthly: 'Monthly',
            total_rebate_amount: 'Total Rebate Amount',
            approver: 'Approver',
            approve_time: 'Approvel Time',
            export_status: 'Export Status',
            export_sap_status: 'Export Sap Status',
            time_limit: 'Time Limit',
            submit_sap: 'Submit SAP',
            batch_edit_pay_status: 'Batch Edit Pay Status',
            change_pay_status: 'Change Pay Status',
            quarterly_recalibration: 'Calculation',
            appeal_recalibration: 'Appeal Calculation',
            rebate_calculate: 'Rebate Calculation',
            please_confirm_that_the_bulk_adjustment_payment_status:
                'Please confirm that the bulk adjustment payment status：',
            please_confirm_that_the_payment_has_been_completed:
                'Please confirm that the payment has been completed',
            click_to_pass: 'Click ‘Pass’ to pass all of selected items.',
            click_to_approved: 'Click ‘Approved’ to pass all of selected items.',
            colour: 'Colour',
            sales_target: 'Sales Target',
            actual_sales: 'Actual Sales',
            achieving_rate: 'Achieving Rate',
            approval_opinion: 'Approval opinion',
            approval_remark: 'Remarks for superior approval',
            remark: 'Remark:',
            batch_pass: 'Batch Pass',
            approval_history: 'Approval History',
            approval_result: 'Approval Result',
            invoice_amount: 'Invoice Amount',
            invoice_amount_vat: 'Invoice Amount(Incl.VAT)',
            adjust_sales: 'Adjust Sales',
            fleet: 'Fleet',
            month: 'Month',
            sales: 'Sales',
            sales_volume: 'Sales Volume',
            regs: 'Regs',
            total_target: 'Total Target',
            total_sales: 'Total sales',
            select_quarter: 'Select Quarter',
            select_quarter_rek:
                'Please select the periods or KPI policy that you want to calculate.',
            select_quarter_down:
                '*The items in the drop-down box are the data for the currently starting billing process',
            reasons_for_appeal: 'Reasons For Appeal',
            d_reasons_for_appeal: 'Reason For Dealer Appeal',
            rebate_name: 'Rebate Name',
            unconfirm: 'Unconfirm (NET)',
            unpayment: 'Unpayment (NET)',
            unpayment_vat: 'Confirmed Unpaid (Incl.VAT)',
            confirm: 'Confirm (NET)',
            paid: 'Paid (NET)',
            sales_are_correct: 'Sales Are Correct',
            target_are_correct: 'Target Are Correct',
            confirm_tip:
                'Please confirm the sales order quantity in this quarter. After confirmed, the sales data (target and sales) cannot be change.',
            clear_tip:
                'Please confirm that the confirmation status of the selected row will be cleared.',
            pass_tips: 'Click "Pass" to pass all of selected items.',
            payment_per_unit: 'Payment Per Unit',
            ladder_bonus: 'Ladder Bonus (NET)',
            ladder_fleet: 'Dealer Fleet (NET)',
            average_bonus: 'Average Bonus (NET)',
            confirm_net: 'Confirm (NET)',
            m1_advance_payment: 'M1 Advance Payment (NET)',
            m1_advance_payment_vat: 'M1 Advance Payment (Incl.VAT)',
            m2_advance_payment: 'M2 Advance Payment (NET)',
            m2_advance_payment_vat: 'M2 Advance Payment (Incl.VAT)',
            payment_amount_net: 'Payment Amount (NET)',
            mumber_of_payment: 'Number of Payment',
            target_sales_adj: 'Target/Sales Adj',
            submit_date: 'Submit Date',
            batch_apply_payment: 'Batch Apply Payment',
            batch_apply_payment_tip: 'Please confirm the submission of the selected results!',
            comment: 'Comment',
            payment_approval: 'Payment Approval',
            region: 'Region',
            batch_import_of_adjustments: 'Batch Import Of Adjustments',
            adjustment_item: 'Adjustment Item',
            please_download_invoice: 'Invoice Download',
            current_total_payment_amount: 'Current Total Payment Amount',
            paid_date: 'Paid Date',
            des_reminders_for_dealer: 'In processing, unable to submit',
            des_reminders_for_dealer_no_chance: 'There is no chance to appeal',
            balance_due_difference: 'new balance due - old balance due:',
            computation_reminder: 'Price Term and Order Type is required',
            incl_vat: 'Payment Amount(Incl.VAT)',
            tip_adjustment: 'Custom row adjustment column or Adjustment Reason required',
            achievement_thresholds: 'Achievement Thresholds',
            total_confirmed: 'Total Confirmed (Incl.VAT)',
            confirm_status: 'Confirm Status',
            confirm_completion: 'Confirm Completion',
            appeal_status: 'Appeal Status',
            filter: 'filter',
            clear: 'clear',
            confirmed_amount: 'Confirmed Amount(Incl.VAT)',
            sales_date: 'Sales Date',
            order_cancel_date: 'Order Cancel Date',
            whole_sale_margin: 'Whole Sale Margin',
            retail_margin: 'Retail Margin',
            bouns: 'Bouns',
            de_for_nonCompliance: 'Deduction for non_compliance',
            dt_code: 'DT',
            dt_codes: 'DT Code',
            eu_rebate_no: 'Rebate No.',
            eu_accrual_no: 'Accrual No.',
            eu_total_adjustment: 'Total Adjustment',
            eu_msrp_vat: 'MSRP(w/o VAT)',
            eu_msrp_vatr: 'MSRP(Incl.VAT)',
            eu_msrp_net: 'Net MSRP',
            eu_color_price_vat: 'Color Price(Incl.VAT)',
            eu_exterior_color_price: 'Exterior Color Price',
            eu_last_approver: 'Last Processor',
            eu_latest_time: 'Latest Update Time',
            eu_retail_volume: 'Retail Volume',
            eu_wholesales_volume: 'Wholesales Volume',
            eu_rebate_deduction_no: 'Rebate No/Deduction No',
            eu_rebate_deduction_name: 'Rebate Name/Deduction Name',
            eu_remark: 'Remark',
            eu_remark_return: 'Approval Opinion is required！',
            eu_pay_tip:
                'Please confirm that the payment has been completed. The status can not be changed after this operation.',
            eu_trim: 'Trim',
            eu_rebate_type: 'Rebate Type',
            eu_calculation_time: 'Calculation Time',
            eu_payment_time: 'Payment Time',
            eu_bonus: 'Bonus',
            eu_bonus_vat: 'Bonus(VAT Incl.)',
            eu_wholesales_orders: 'Wholesales Orders',
            eu_retail_orders: 'Retail Orders',
            eu_vehicle_material_code: 'Vehicle Material Code',
            eu_order_cancelled_code: 'Order Cancelled Date',
            eu_process_status: 'Process Status',
            eu_process_date: 'Process Time',
            eu_registration_code: 'Registration Code',
            eu_registration_Date: 'Registration Date',
            eu_key: 'Key',
            eu_ttl: 'TTL',
            eu_total_support_id: 'Total Support(Incl.Invoice Discount)',
            eu_invoice_price_vat: 'Invoice Price(Excl.VAT)',
            eu_invoice_discount_vat: 'Invoice Discount(Excl.VAT)',
            eu_tip_adjustment:
                'When the adjustment column or adjustment reason column of a custom row has a value, the other one is required',
            eu_exterior_code: 'Exterior Code',
            eu_is_export: 'Is Export',
            eu_generate_credit: 'Generate Credit Note',
            eu_settlement_currency: 'Sales Company',
            after_advance_vat: 'Amount Due after Advance (Incl.VAT)',
            initial_total_vat: 'Initial Total (Incl.VAT)',
            appeals_adjustments_amount_vat: 'Appeals & Adjustments Amount (Incl.VAT)',
            total_unconfirmed_vat: 'Total Unconfirmed (Incl. VAT)',
            eu_marketing_activity: 'Marketing Activity',
            eu_marketing_activity_name: 'Marketing Activity Name',
            eu_activity_startdate: 'Activity Start Date',
            eu_activity_enddate: 'End Date',
            flag_as_a_ticket: 'Flag as a Ticket',
            eu_tip_ticket: 'No data submitted',
            billing_group: 'Billing Group',
            adjustment_amount_net: 'Adjustment Amount(NET)',
            eu_export_sap: 'Export SAP Status',
            eu_tip_other_msg: 'When submitting a single appeal, the "Appeal Reply" is required.',
            eu_tip_apply: 'When submitting a full appeal, the "Appeal Reply" is required.',
            eu_dealer_region: 'Dealer Region',
            eu_inlog_type: 'Type',
            eu_inlog_amount: 'Amount（Incl.VAT)',
            eu_inlog_invoice: 'Invoice',
            eu_inlog_operator: 'Operator',
            eu_list_price_net: 'List Price(NET)',
            eu_color_price_net: 'Color Price(NET)',
            eu_interior_price_net: 'Interior Price(NET)',
            eu_seat_price_net: 'Seat Price(NET)',
            eu_roof_price_net: 'Roof Price(NET)',
            eu_invoice_status: 'Invoice Status',
            unpaid_vat: 'Unpaid(Incl.VAT)',
            paid_vat: 'Paid (Incl.VAT)',
            eu_amount_due_after_advance: 'Amount Due After Advance(NET)',
            eu_confirm_amount_vat: 'Confirmed Amount (Incl. VAT)',
            eu_unconfirm_amount_vat: 'Unconfirmed Amount (Incl. VAT)',
        },
        deDe: {
            serial_number: 'Nr.',
            eu_rebate_name: 'Prämie',
            eu_customer_code: 'Händlernummer',
            eu_customer_name: 'Händlername',
            eu_customer_status: 'Händlerstatus',
            settlement_period: 'Abrechnungszeitraum',
            approval_status: 'Genehmigungsstatus',
            pay_status: 'Zahlungsstatus',
            confirmation_status: 'Status',
            eu_advance_payment: 'Vorauszahlung',
            eu_total_support_net: 'Gesamtbetrag (Netto)',
            eu_total_support_vat: 'Gesamtbetrag (Brutto)',
            eu_currency: 'Abrechnungswährung',
            eu_unpaid: 'nicht gezahlt',
            eu_paid: 'gezahlt',
            appeal_update: 'Reklamationsaktualisierung',
            eu_policy_name: 'Prämienprogramm-Name',
            create_time: 'Erstelldatum',
            detail: 'Detail',
            confirm_btn: 'Bestätigen',
            operation: 'Aktion',
            date: 'Datum',
            more: 'Mehr',
            eu_kpi_name: 'KPI-Prämienbezeichnung',
            target: 'Ziel',
            reg: 'Zulassung',
            summary: 'Gesamt',
            net: 'Netto',
            vat: 'Steuer',
            total: 'Gesamt',
            total_support: 'Gesamtbetrag',
            eu_unpaid_de: 'Offen',
            vin: 'FIN',
            dealer_feedback_status: 'Händler Status',
            confirmation_date: 'Bestätigungs-Datum',
            appeal_reason: 'Reklamationsgrund',
            other_msg: 'Reklamationsantwort',
            eu_material_code: 'Material Code',
            model_version: 'Modell / Variante',
            color: 'Farbe',
            reg_date: 'Zulassungsdatum',
            eu_reg_filling_date: 'Reg Filling Date',
            quote_disount_net: 'Quote Disount(NET)',
            quote_disount_vat: 'Quote Disount(wVAT)',
            declaration_late: 'Declaration Late',
            estimated_delivery_date: 'Estimated Delivery Date',
            delivery_late: 'Delivery Late',
            eu_order_active_date: 'Order Activated Date',
            eu_first_reg_date: 'Erstzulassung',
            reg_cancel_date: 'Abmeldedatum',
            order_type: 'Auftragsart',
            eu_price_term: 'Price Term',
            vehicle_type_history: 'Fahrzeugtyp-Verlauf',
            business_customer: 'Geschäftskunde',
            company_size: 'Unternehmensgröße',
            ventes_en_lot: 'Ventes En Lot',
            eu_business_type: 'Business Type',
            eu_fleet_type: 'Fleet Type',
            eu_gate_out_date: 'Ausgangsdatum',
            order_date: 'Bestelldatum',
            contract_date: 'Vertragsdatum',
            inquiry_date_bank: 'Anfragedatum',
            order_date_bank: 'Bestelldatum (Bank)',
            quantity: 'Menge',
            eu_msrp: 'UVP',
            eu_list_price: 'Listenpreis',
            eu_color_price: 'Preis Außenfarbe',
            eu_interior_price: 'Preis Innenfarbe',
            eu_currency_de: 'Währung',
            adjustment_de: 'Anpassung',
            adjustment_reason_de: 'Anpassungsgrund',
            eu_total_support_net_de: 'Netto Betrag gesamt',
            eu_total_support_vat_de: 'Brutto Betrag gesamt',
            eu_vat_rate: 'Steuersatz',
            financial_support: 'Finanzielle Förderung',
            appealed_history: 'Reklamationsverlauf',
            appeal_files: 'Anhänge',
            export: 'Export',
            cancel: 'Abbruch',
            appeal_reason_desc:
                'Wenn Sie Einwände gegen die gesamte Abrechnung haben, geben Sie hier bitte den Grund für Ihre Reklamation ein.',
            eu_tip_adjustment:
                'When the adjustment column or adjustment reason column of a custom row has a value, the other one is required',
            eu_tip_ticket: 'No data submitted',
            file_name: 'Dateiname',
            operater: 'Bearbeiter',
            upload_time: 'Hochladezeitpunkt',
            version_no: 'Versionsnr.',
            username: 'Benutzername',
            help: 'Hilfe',

            invoice_date: ' Invoice Date',
            eu_delivery_date: 'Delivery Date',
            eu_wholesales_order_type: 'Wholesales Order Type',
            wholesale_invoice_number: 'Wholesale Invoice Number',
            wholesale_invoice_date: 'Wholesale Invoice Date',
            wholesale_invoice_amount: 'Wholesale Invoice Amount',
            basic_price: 'Basic Price',
            eu_dealer_appeal: 'Reklamation', // Einspruch
            eu_dealer_confirm: 'Bestätigen',
            eu_dealer_generate_pdf: 'PDF generieren',
            eu_dealer_invoice_pdf: 'Rechnung PDF',
            eu_dealer_invoice: 'Rechnung',
            eu_invoice_status: 'Bereits heruntergeladen',
            unpaid_vat: 'Unpaid(Incl.VAT)',
            paid_vat: 'Paid (Incl.VAT)',
            eu_amount_due_after_advance: 'Betrag nach Abzug des Vorschusses (netto)',
            eu_confirm_amount_vat: 'Bestätigter Betrag (inkl. MwSt.)',
            eu_unconfirm_amount_vat: 'Nicht bestätigter Betrag (inkl. MwSt.)',
        },
    },
};
